import { Box, ButtonBase, Divider } from '@mui/material';
import { DateRangeIcon } from '@mui/x-date-pickers';
import { useNavigate } from 'react-router';

import { DataHubCard } from '@/features/DataHub/components/DataHubCard';
import { useDataHubUserConfig } from '@/features/DataHub/hooks/useDataHubUserConfig';
import { MIN_DATE } from '@/features/DataHub/modules/Export/constants/dateSettings';
import { useExportSettings } from '@/features/DataHub/modules/Export/context/ExportSettingsContext';
import { ExportTypes } from '@/features/DataHub/modules/Export/types';
import { useAppDispatch, useAppSelector } from '@/hooks/redux-hooks';
import { closeDrawer } from '@/slices/drawerSlice';

import DateRangeSettingsFields from './DateRangeSettingsFields';

const DateSettings = () => {
  const navigate = useNavigate();
  const { exportSettings } = useExportSettings();

  const exportType = useAppSelector(state => state.export.type);

  const { timezoneLabel, dateFormatValue } = useDataHubUserConfig();

  const dispatch = useAppDispatch();

  if (
    exportSettings.exportType === ExportTypes.IMAGE &&
    (exportType === 'seasonal' || exportType === 'forwardSimple')
  ) {
    return null;
  }
  return (
    <DataHubCard
      expandable
      icon={
        <DateRangeIcon
          sx={{
            fontSize: '16px'
          }}
        />
      }
      subtitle='Select date range and timezone options'
      title='Date settings'
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          fontSize: '14px',
          my: 1.5
        }}
      >
        <Divider sx={{ mb: 2 }} />
        <DateRangeSettingsFields
          dateFormat={dateFormatValue}
          maxDate={new Date()}
          minDate={MIN_DATE}
        />
        <Divider sx={{ my: 2 }} />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'baseline'
          }}
        >
          Timezone: {timezoneLabel}{' '}
          <ButtonBase
            sx={{
              ml: 2,
              color: 'primary.main'
            }}
            onClick={() => {
              navigate('/profile');
              dispatch(closeDrawer());
            }}
          >
            Change in Settings
          </ButtonBase>
        </Box>
        <Divider sx={{ mt: 2 }} />
      </Box>
    </DataHubCard>
  );
};

export default DateSettings;
